import { useRef } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@maysoft/common-component-react";
import MuiBox from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";

import Constants from "constants/index";
import InaccessibleLayout from "./inaccessibleLayout";

import { Navbar } from "components";
import { IRecordMenuDetail } from "commons/interfaces";
import { useSelector } from "react-redux";
import { RootState } from "store";
import OtherServiceDetection from "components/OtherServiceDetection";


interface IProps {
    accessible: boolean;
    mainMenu?: IRecordMenuDetail[];
};

const MainLayout = (props: IProps) => {
    const elementRef = useRef(null);
    const w575 = useMediaQuery("(max-width: 575px)");
    const userInfo = useSelector((state: RootState) => state.user.userInfo);

    return (
        <MuiBox
            ref={elementRef}
            sx={{
                backgroundColor: Constants.Styles.COLOR_LAYOUT.BACKGROUND_COLOR_ROOT,
            }}
        >
            {props.accessible &&
                <Box p={"0px 16px"} bgColor="#fff">
                    <Navbar
                        isMobile={w575}
                        mainMenu={props.mainMenu}
                    />
                </Box>
            }

            {/* Child screen element */}
            <MuiBox
                component={"main"}
                sx={{
                    p: 0,
                    flexGrow: 1,
                    width: "100%",
                }}
            >
                {props.accessible ? <Outlet /> : <InaccessibleLayout />}
            </MuiBox>
        </MuiBox>
    );
};

export default MainLayout;
